package ai.beakman.undercover.data

/**
 * Catálogo NEUTRO de idioma: a espinha dorsal estável dos temas.
 *
 * Cada [CatalogTheme] tem um `id` estável, um `emoji` e uma lista ORDENADA de `wordIds`
 * estáveis. Os textos (nome do tema, palavra, dica) por idioma vivem em
 * `ThemeStrings_<lang>` (NAMES + WORDS), indexados por esses mesmos ids.
 *
 * Esquema de wordId: `"<themeId>_<n>"`, com `n` a partir de 1, na ordem do tema.
 * (ex.: "animais_1"..."animais_12"). A ordem aqui deve casar com a de `ThemeStrings_pt`.
 */
data class CatalogTheme(
    val id: String,
    val emoji: String,
    val wordIds: List<String>,
)

object ThemeCatalog {
    /** Gera os wordIds `"<themeId>_1".."<themeId>_count"`. */
    private fun ids(themeId: String, count: Int): List<String> =
        (1..count).map { "${themeId}_$it" }

    /** Temas, na ordem oficial de exibição (espelha o data/Themes.kt original). */
    val THEMES: List<CatalogTheme> = listOf(
        CatalogTheme("animais", "🦁", ids("animais", 12)),
        CatalogTheme("comidas", "🍕", ids("comidas", 12)),
        CatalogTheme("profissoes", "👩‍⚕️", ids("profissoes", 12)),
        CatalogTheme("filmes", "🎬", ids("filmes", 12)),
        CatalogTheme("lugares", "🗺️", ids("lugares", 12)),
        CatalogTheme("esportes", "⚽", ids("esportes", 12)),
    )

    fun byId(id: String): CatalogTheme? = THEMES.firstOrNull { it.id == id }
}
